import {useMutation} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {assignCourseToAdminUrl} from "../../constants/api/soft-user/endpoints";
import {useQueryClient} from "@tanstack/react-query";

export const useMutateAssignCourse = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  async function assignCourse(data: any) {
    if (data.assigned_admin_id) {
      return axios.post(assignCourseToAdminUrl, data)
    }

    return axios.delete(assignCourseToAdminUrl, {
      data: {
        course_recommendation_id: data.course_recommendation_id
      }
    })
  }

  return useMutation({
    mutationKey: ['courses', 'assign-to'],
    mutationFn: assignCourse,
    onSuccess: () => queryClient.invalidateQueries({queryKey: ['assigned-courses']})
  });
}